/* eslint-disable import/no-anonymous-default-export */
import base64 from 'react-native-base64'
import requestOptions from './requestOptions'

// import validationLogin from '../validation/login'

const loginService = async (user, password) => {
    try {
        const token = base64.encode(user + ':' + password)
        const options = requestOptions.options('POST', token, '')
        const resp = await fetch(global.LOGIN, options)
        const response = await resp.json();
        return response;
    } catch (error) {
        localStorage.clear();
        window.location.href = '/';
    }
}

const setPaswordLink = async (email, link) => {
    try {
        const token = base64.encode(email + '_' + link)
        const options = requestOptions.options('POST', token, '')
        const resp = await fetch(global.SENDLINK, options)
        const response = await resp.json();
        return response;
    } catch (error) {
        localStorage.clear();
        window.location.href = '/';
    }
}

const changePassword = async (password, passwordConfirm, token) => {
    try {
        const info = base64.encode(password + ' ' + token)
        const options = requestOptions.options('POST', info, '')
        const resp = await fetch(global.CHANGEPASSWORD, options)
        const response = await resp.json();
        return response;
    } catch (error) {
        localStorage.clear();
        window.location.href = '/';
    }
}

export default {
    loginService,
    setPaswordLink,
    changePassword
}
